import { IOrganization } from 'app/shared/model/organization.model';

export interface ISerialNumberRange {
  id?: number;
  name?: string;
  org?: IOrganization | null;
}

export const defaultValue: Readonly<ISerialNumberRange> = {};
